import { z } from 'zod'

export const AddressMasterDataSchema = z.object({
  address_master_id: z.number().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  full_street_address: z.string().nullable(),
  postal_community: z.string().nullable(),
  state: z.string().nullable(),
  zip5: z.string().nullable(),
  zip4: z.string().nullable(),
  subdivision_name: z.string().nullable(),
  community_name: z.string().nullable(),
  street_number: z.string().nullable(),
  street: z.string().nullable(),
  street_type: z.string().nullable(),
  unit_type: z.string().nullable(),
  unit_nbr: z.string().nullable(),
  pre_directional: z.string().nullable(),
  post_directional: z.string().nullable(),
})
export type AddressMasterData = z.infer<typeof AddressMasterDataSchema>
